// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__1Y9kq","title":"styles_title__2SFQW"};